import React, { useEffect, useState } from "react";
import { AppstoreAddOutlined } from "@ant-design/icons";
import { Button } from "reactstrap";
import { Firestore, Auth } from "../config/firebase";

class CollectionsView extends React.Component {
  state = {
    collections: []
  };
  componentDidMount() {
    if (Auth.currentUser) {
      Firestore.collection("users")
        .doc(Auth.currentUser.uid)
        .onSnapshot(doc => {
          if (typeof doc.data().collections != "undefined") {
            this.setState({ collections: doc.data().collections });
          }
        });
    }
  }

  handleCollection = () => {
    if (Auth.currentUser) {
      this.props.action();
    } else {
      this.props.history.push("/login");
    }
  };
  render() {
    const { collections } = this.state;
    return (
      <Button
        className="btn-lg m-2"
        outline
        color={collections.includes(this.props.id) ? "primary" : "secondary"}
        onClick={this.handleCollection}
      >
        <AppstoreAddOutlined />{" Bookmark"}
      </Button>
    );
  }
}

export default CollectionsView;
